import "./AppBar.scss";

import React, { Component } from "react";
import { makeObservable, observable } from "mobx";
import { inject, observer } from "mobx-react";
import { Drawer, Modal, Select, Input, Tooltip, Divider, Radio, Slider } from "antd";
import classnames from "classnames";
import { translateKey as t } from "../../locales/translation";
import PageTitle from "./PageTitle";
import { AppStore } from "~/stores/AppStore";
import { awesomeIcon, getCountryFlag } from "../../utils/helpers";
import { environmentHostOf } from "../../utils/partnerEnvironment";
import keyboardJS from "keyboardjs";
import { common } from "../../utils/common";
import { OFNotifications } from "../OFNotifications/OFNotifications";

import _ from "lodash";

const { Option } = Select;
const { Search } = Input;

@inject("store")
@observer
export class AppBar extends Component<{
  store?: AppStore;
  fixed?: boolean;
}> {
  searchInputRef = null;
  drawerActive = false;
  settingsDialog = false;
  activeCategory = "";
  catSearch = "";
  hoveredItem = null;
  hoveredIcon = null;
  hoveredTopMenuItem = null;
  hoveredTopMenuIcon = null;

  constructor(props) {
    super(props);
    makeObservable(this, {
      searchInputRef: observable,
      drawerActive: observable,
      settingsDialog: observable,
      activeCategory: observable,
      catSearch: observable,
      hoveredItem: observable,
      hoveredIcon: observable,
      hoveredTopMenuItem: observable,
      hoveredTopMenuIcon: observable,
    });
  }

  public componentDidMount() {
    // Apply keyboard bindings.
    this.applyKeyboardBindings();
  }

  public componentWillUnmount() {
    keyboardJS.reset();
  }

  private applyKeyboardBindings() {
    // Get OS data.
    let os = common.getOS();

    // Menu shortcut.
    let menuLaunch = os === "macOS" ? "command+/" : "ctrl+/";
    keyboardJS.bind(menuLaunch, (e) => {
      this.handleDrawerToggle();
    });
  }

  private languages = [
    { id: "en", name: "English", countryCode: "gb" },
    { id: "de", name: "Deutsch", countryCode: "de" },
    { id: "pl", name: "Polski", countryCode: "pl" },
    // { id: 'en', name: 'English' },
    // { id: 'fr', name: 'French' },
    // { id: 'it', name: 'Italian' },
    // { id: 'pl', name: 'Polish' },
    // { id: 'de', name: 'German' }
  ];

  private handleCatExpand = (index) => {
    if (this.activeCategory === index) {
      this.activeCategory = "";
    } else {
      this.activeCategory = index;
    }
  };

  private handleLogoClick = (e) => {
    // if (e.detail === 3) {
    //   this.props.store.showClientLogos = !this.props.store.showClientLogos;
    //   window.localStorage.setItem("showClientLogos", this.props.store.showClientLogos ? "true" : "false");
    //   document.location.reload();
    // }
  };

  private checkForMatches = (value: string) => {
    const valToLow = value.toLowerCase();
    const searchToLow = this.catSearch.toLowerCase();

    if (valToLow.includes(searchToLow)) {
      return true;
    }

    return false;
  };

  private addToFavorites = async (e, route, routeGroup) => {
    e.preventDefault();

    const favoritePage = {
      name: route.name,
      translationKey: route.translationKey,
      routeGroup: routeGroup.name,
      routeGroupTranslationKey: routeGroup.translationKey,
      path: route.linkTo,
      _id: route._id,
    };

    await this.props.store.updateUserPreferences(`pageSettings.favorites[${route._id}]`, favoritePage);
  };

  private hoveredRouteItem = (index, route, routeGroup) => {
    if (this.hoveredItem !== index) {
      return;
    }

    if (this.props.store.loadingUserPreferences) {
      return awesomeIcon("loader");
    }

    const { getUserPreferences } = this.props.store;
    const favorites = getUserPreferences("pageSettings.favorites", {});
    const isFavorite = favorites[route._id] || false;
    const maxFavorites = 5;

    if (Object.values(favorites).length < maxFavorites || isFavorite) {
      return (
        <Tooltip placement="right" title={isFavorite ? t("lblUnpin", "Unpin") : t("lblPinToTop", "Pin To Top")} mouseLeaveDelay={0}>
          <div
            onMouseEnter={() => (this.hoveredIcon = index)}
            onMouseLeave={() => (this.hoveredIcon = null)}
            className="absolute right-0"
            style={{ padding: 10, background: this.hoveredIcon === index ? "#d9dae4" : "#f0eff4" }}
            onClick={async (e) => {
              e.preventDefault();

              if (isFavorite) {
                delete favorites[route._id];
                await this.props.store.updateUserPreferences("pageSettings.favorites", favorites);
              } else {
                await this.addToFavorites(e, route, routeGroup);
              }

              this.hoveredIcon = null;
              this.hoveredItem = null;
            }}
          >
            {/* {isFavorite ? <Icon type="pushpin" theme="filled" /> : <Icon type="pushpin" />} */}
            {isFavorite ? awesomeIcon("thumb-tack", "2x", {}, "solid") : awesomeIcon("thumb-tack", "2x", {}, "regular")}
          </div>
        </Tooltip>
      );
    }

    return (
      <Tooltip placement="right" title={t("lblMaximumPinnedRoutesReached", "Maximum pinned routes reached")} mouseLeaveDelay={0}>
        <div onClick={(e) => e.preventDefault()}>
          {/* <Icon type="pushpin" style={{ cursor: "not-allowed" }} /> */}
          {awesomeIcon("thumb-tack", "2x", { cursor: "not-allowed" }, "regular")}
        </div>
      </Tooltip>
    );
  };

  private hoveredMenuItem = (index, route, routes, mostViewed = false) => {
    if (this.hoveredTopMenuItem !== index) {
      return;
    }

    const { getUserPreferences, updateUserPreferences } = this.props.store;

    return (
      <Tooltip placement="right" title={t("lblRemove", "Remove")} mouseLeaveDelay={0}>
        <div
          onMouseEnter={() => (this.hoveredTopMenuIcon = index)}
          onMouseLeave={() => (this.hoveredTopMenuIcon = null)}
          className="topMenu absolute right-0"
          style={{ padding: 10, background: this.hoveredTopMenuIcon === index ? "#d9dae4" : "#f0eff4" }}
          onClick={(e) => {
            e.preventDefault();

            if (mostViewed) {
              const most = getUserPreferences("pageSettings.most", []);
              most.splice(index, 1);
              updateUserPreferences("pageSettings.most", most);
            } else {
              delete routes[route._id];
              updateUserPreferences("pageSettings.favorites", routes);
            }

            this.hoveredTopMenuIcon = null;
            this.hoveredTopMenuItem = null;
          }}
        >
          {
            this.hoveredTopMenuIcon === index
              ? awesomeIcon("close", "2x", {}, "solid")
              : // <Icon type="close-circle" theme="filled" />
                awesomeIcon("close", "2x", {}, "regular")
            // <Icon type="close-circle" />
          }
        </div>
      </Tooltip>
    );
  };

  private getCatIcon = (icon) => {
    return awesomeIcon(icon, "lg");
  };

  private renderMenu = () => {
    const menuMarkup = [];
    const externalLinks = this.props.store.getClientPreference("externalLinks", []);

    if (this.props.store.user.routes) {
      let sortedRoutes = this.props.store.user.routes.slice().sort((a, b) => a.sequence - b.sequence);

      let rootItems = [];

      sortedRoutes.forEach((routeGroup, index) => {
        //Do not show route group Login
        if (routeGroup.name.toLowerCase() === "login") {
          return;
        }

        const menuItems = [];
        const isActive = this.catSearch || this.activeCategory === index;

        //to add menuItem sequence
        routeGroup.userRoutes.forEach((route, i) => {
          //hide bypassed links in menu specified in config
          if (!route.bypass) {
            if (this.catSearch) {
              if (this.checkForMatches(t(route.translationKey, route.name))) {
                menuItems.push(
                  <a href={route.linkTo} className="block" key={route._id}>
                    <div className="menuItem" onMouseEnter={() => (this.hoveredItem = i)} onMouseLeave={() => (this.hoveredItem = null)}>
                      <span className="flex-1">{t(route.translationKey, route.name)}</span>
                      {this.hoveredRouteItem(i, route, routeGroup)}
                    </div>
                  </a>
                );
              }
            } else {
              menuItems.push(
                <a href={route.linkTo} className="block" key={route._id}>
                  <div className="menuItem" onMouseEnter={() => (this.hoveredItem = i)} onMouseLeave={() => (this.hoveredItem = null)}>
                    <span className="flex-1">{t(route.translationKey, route.name)}</span>
                    {this.hoveredRouteItem(i, route, routeGroup)}
                  </div>
                </a>
              );
            }
          }
        });

        if (menuItems.length > 0) {
          menuMarkup.push(
            <div className="categoryContainer" key={index}>
              <div className={"category" + (isActive ? " stuck" : "")} onClick={() => this.handleCatExpand(index)}>
                {this.getCatIcon(routeGroup.leftIcon)}
                <span className="title">{t(routeGroup.translationKey, routeGroup.name)}</span>
                <span className={"catIcon" + (isActive ? " active" : "")}>{awesomeIcon("angle-down", "lg")}</span>
              </div>
              <div className="categoryItems" style={{ display: isActive ? "block" : "none" }}>
                {menuItems}
              </div>
            </div>
          );
        }
      });

      menuMarkup.unshift(...rootItems);
    }

    if (externalLinks.length > 0) {
      const links = [];

      externalLinks.forEach((link, i) => {
        if (this.checkForMatches(link.name)) {
          links.push(
            <div className="categoryContainer" key={"external" + i}>
              <div className={"category"} onClick={() => window.open(link.url, "_blank")}>
                <img alt={"icon"} style={{ marginRight: 10, height: 18, flex: 1 }} src={link.icon} />
                <span className="title" style={{ textTransform: "none" }}>
                  {link.name}
                </span>
                <span className={"catIcon"}>{awesomeIcon("external-link-alt")}</span>
              </div>
            </div>
          );
        }
      });

      if (links.length > 0) {
        menuMarkup.push(
          <Divider key="externalLinks" style={{ color: "#616384", margin: "7px 0" }}>
            External Links
          </Divider>
        );

        menuMarkup.push(...links);
      }
    }

    if (menuMarkup.length === 0 && this.catSearch) {
      return <div className="noMatches">{t("lblNoMatchesFoundForItem", 'No matches found for "{1}"', [this.catSearch])}</div>;
    }

    return menuMarkup;
  };

  private renderUserDetails = () => {
    const { firstName, lastName, email } = this.props.store.user;

    return (
      <div className="flex">
        <div className="flex flex-col flex-1">
          <div className="name">{firstName + " " + lastName}</div>
          <div>{email}</div>
        </div>
      </div>
    );
  };

  private renderQuickActionButtons = () => {
    return (
      <div className="flex">
        {/* <Tooltip placement='top' title='Report Bug' mouseEnterDelay={0} mouseLeaveDelay={0}>
          <div
            className='quickActionBtns'
            onClick={() => {
              this.closeDrawer()
              this.props.store.bugReport.openReportModal()
            }}
          >
            {awesomeIcon('faBug', 'lg')}
          </div>
        </Tooltip> */}
        <Tooltip placement="top" title={t("lblSettings", "Settings")} mouseEnterDelay={0} mouseLeaveDelay={0}>
          <div
            className="quickActionBtns"
            onClick={() => {
              this.closeDrawer();
              this.settingsDialog = true;
            }}
          >
            {awesomeIcon("cog", "lg")}
          </div>
        </Tooltip>
        <Tooltip placement="top" title={t("lblLogout", "Log Out")} mouseEnterDelay={0} mouseLeaveDelay={0}>
          <div className="quickActionBtns" onClick={() => this.props.store.signOut()}>
            {awesomeIcon("sign-out-alt", "lg")}
          </div>
        </Tooltip>
      </div>
    );
  };

  private handleDrawerToggle = () => {
    this.drawerActive = true;

    // Autofocus the search input
    setTimeout(() => {
      this.searchInputRef && this.searchInputRef.focus();
    }, 200);
  };

  private closeDrawer() {
    this.drawerActive = false;
    this.activeCategory = "";
    this.catSearch = "";
  }

  private renderMostVisitedPages = () => {
    const elements = [];
    const favorites = this.props.store.getUserPreferences("pageSettings.favorites");

    const mostPages = this.props.store.getPageStats();

    elements.push(
      <a href="/home" className="block" key="/home">
        <div className="menuItem">
          {awesomeIcon("home", "lg")}
          <b>{t("lblHome", "Home")}</b>
        </div>
      </a>
    );

    if (Object.values(favorites).length > 0) {
      Object.values(favorites).forEach((fav: any, i) => {
        if (fav.visible === false) {
          return;
        }

        elements.push(
          <a href={fav.path} className="block" key={fav.path}>
            <div className="menuItem" onMouseEnter={() => (this.hoveredTopMenuItem = i)} onMouseLeave={() => (this.hoveredTopMenuItem = null)}>
              <div className="flex-1 flex items-center">
                {awesomeIcon("thumb-tack", "lg", {}, "solid")}
                {/* <Icon type="pushpin" theme="filled" style={{ fontSize: 21 }} /> */}
                <div>
                  <b>{t(fav.translationKey, fav.name)}</b>
                  {" - "}
                  <span>{t(fav.routeGroupTranslationKey, fav.routeGroup)}</span>
                </div>
              </div>

              {this.hoveredMenuItem(i, fav, favorites)}
            </div>
          </a>
        );
      });
    } else if (mostPages) {
      mostPages.most.forEach((p, i) => {
        elements.push(
          <a href={p.path} className="block" key={p.path}>
            <div className="menuItem" onMouseEnter={() => (this.hoveredTopMenuItem = i)} onMouseLeave={() => (this.hoveredTopMenuItem = null)}>
              <div className="flex-1 flex items-center">
                {awesomeIcon("star", "lg")}
                <div>
                  <b>{t(p.translationKey, p.name)}</b>
                  {" - "}
                  <span>{t(p.routeGroupTranslationKey, p.routeGroup)}</span>
                </div>
              </div>

              {this.hoveredMenuItem(i, p, mostPages.most, true)}
            </div>
          </a>
        );
      });
    }

    return <div>{elements}</div>;
  };

  private handleColorModeChange = (value) => {
    if (value === "color") {
      document.body.style.removeProperty("filter");
      localStorage.removeItem("grayscale");
      this.props.store.grayscale = null;
    } else {
      this.props.store.grayscale = 5;
      localStorage.setItem("grayscale", "5");
      document.body.style.filter = `grayscale(${1})`;
    }
  };

  private handleGrayscaleChange = (value) => {
    this.props.store.grayscale = value;
    localStorage.setItem("grayscale", value.toString());

    document.body.style.filter = `grayscale(${value / 5})`;
  };

  render() {
    const className = classnames("appBar", {
      fixed: this.props.fixed,
    });

    const partnerLogo = this.props.store.getPartnerLogo();

    let appBarStyle = {};

    if (this.props.store.user.ofEnvType === "production" && process.env.NODE_ENV === "development") {
      appBarStyle = {
        background: "#B71C1C",
      };
    }

    // PRO-84: let ADMINs see which OpenFleet stack (ofProviderUrl) this console session is bound to.
    const isAdmin = (_.get(this.props.store, "user.roles", []) || []).includes("ADMIN");
    const environmentHost = isAdmin ? environmentHostOf(_.get(this.props.store, "user.ofProviderUrl", null)) : null;

    return (
      <div style={{ flex: "0 40px" }}>
        <div className={className} style={appBarStyle}>
          <div className="left">
            <div className="menuBtn" onClick={() => this.handleDrawerToggle()}>
              {/* <Icon type="menu" /> */}
              {awesomeIcon("bars")}
            </div>

            <a href="/home" className="brand">
              <div className="appLogo" />
              <div className="appTitle">openFleet Pro</div>
            </a>
            <div className="brand" style={{ marginRight: 4 }}>
              <div className="loqusLogo" />
            </div>
            {this.props.store.showPartnerLogos && partnerLogo && (
              <div className="brand ml-1">
                <img src={partnerLogo} style={{ height: 14 }} alt="" />
              </div>
            )}
            {/* 
            {this.props.store.showClientLogos && this.props.store.getCustomLogo() && (
              <div className="brand">
                <img src={this.props.store.getCustomLogo()} style={{ height: 22 }} alt="" />
              </div>
            )} */}
            {/* {this.props.store.showClientLogos && this.props.store.getCustomLogo(false) && (
              <div className="brand">
                <img src={this.props.store.getCustomLogo(false)} style={{ height: 22 }} alt="" />
              </div>
            )} */}
            <PageTitle />
          </div>
          {(this.props.store.showClientLogos || environmentHost) && (
            <div className="right">
              {environmentHost && (
                <div className="clientRef text-xs" title={t("lblCurrentEnvironment", "Current environment") + ": " + this.props.store.user.ofProviderUrl}>
                  {environmentHost}
                </div>
              )}
              {this.props.store.showClientLogos && _.get(this.props.store, "user.clientRef", null) && <div className="clientRef font-semibold">{this.props.store.user.clientRef}</div>}
            </div>
          )}
        </div>

        <OFNotifications />

        <Drawer
          placement="left"
          closable={false}
          onClose={() => this.closeDrawer()}
          open={this.drawerActive}
          width={300}
          className="sideMenuDrawer"
          // styles={{ padding: "0px", background: "#fafafa", height: "100%" }}
        >
          <div className="drawerContainer">
            <div className="drawerHeader">
              <div className="brand">
                <div className="flex flex-1">
                  <div className="appLogo" onClick={this.handleLogoClick} />
                  <div className="appTitle">openFleet Pro</div>
                </div>
                {this.renderQuickActionButtons()}
              </div>
            </div>

            <div className="drawerFavorites">{this.renderMostVisitedPages()}</div>
            <div className="drawerSearchContainer">
              <Search
                ref={(ref) => (this.searchInputRef = ref)}
                className="drawerSearch"
                placeholder={t("lblTypeToSearch", "Type to search") + "..."}
                allowClear={true}
                onChange={(e) => (this.catSearch = e.target.value)}
                value={this.catSearch}
              />
            </div>

            <div className="drawerMenu">{this.renderMenu()}</div>
            <div className="userContainer">{this.renderUserDetails()}</div>
          </div>
        </Drawer>

        <Modal title={t("lblSettings", "Settings")} centered={true} open={this.settingsDialog} footer={null} onOk={() => (this.settingsDialog = false)} onCancel={() => (this.settingsDialog = false)}>
          <Divider style={{ marginTop: 0 }} orientation="left">
            {t("lblLanguage", "Language")}
          </Divider>
          <Select
            style={{ width: 200 }}
            placeholder={t("lblSelectLanguage", "Select Language")}
            value={this.props.store.language}
            onChange={(lang) => this.props.store.changeLanguage(lang)}
            loading={this.props.store.loadingUserPreferences}
          >
            {this.languages.map((lang) => {
              return (
                <Option key={lang.id} value={lang.id}>
                  <div className="flex items-center">
                    <img alt={"flag"} style={{ width: 20, marginRight: 10 }} src={getCountryFlag(lang.countryCode)} />
                    {lang.name}
                  </div>
                </Option>
              );
            })}
          </Select>

          <Divider orientation="left">{t("lblAccessibility", "Accessibility")}</Divider>

          <div style={{ marginBottom: "5px" }}>
            <b>{t("lblColourMode", "Colour Mode")}</b>
          </div>

          <Radio.Group value={this.props.store.grayscale ? "grayscale" : "color"} onChange={(e) => this.handleColorModeChange(e.target.value)}>
            <Radio value="color">{t("lblColor", "Colour")}</Radio>
            <Radio value="grayscale">{t("lblGrayscale", "Grayscale")}</Radio>
          </Radio.Group>

          {this.props.store.grayscale && <Slider max={5} min={1} dots={true} value={this.props.store.grayscale} onChange={(value) => this.handleGrayscaleChange(value)} />}
        </Modal>
      </div>
    );
  }
}
